/**
 * Returns suggestion fetch function
 * @param apiUrl string
 * @returns {{fetchSuggestions: (function(*): Promise<any>)}} function
 */
export function useSuggestions(apiUrl) {
    /**
     * @param term string
     */
    const fetchSuggestions = async (term) => {
        const url = apiUrl + encodeURIComponent(term);
        const apiResponse = await fetch(url);
        return apiResponse.json()
    }
    return {fetchSuggestions};
}
